import {animate, keyframes, style, transition, trigger} from '@angular/animations';

export const dropdown = trigger('dropdown', [
  transition('void => is-actif', [
    style({
      height: 0,
      opacity: 0,
    }),
    animate(
      '.5s cubic-bezier(.32,.9,.9,.96)',
      keyframes([style({height: '*', offset: 0.5}), style({opacity: 1, offset: 1})]),
    ),
  ]),
  transition('is-actif => void', [
    style({
      height: '*',
      opacity: '1',
    }),
    animate(
      '.3s cubic-bezier(.32,.9,.9,.96)',
      keyframes([style({opacity: 0, offset: 0.5}), style({height: 0, offset: 1})]),
    ),
  ]),
]);
